import { render, staticRenderFns } from "./DocumentFolders.vue?vue&type=template&id=4cc8a405&"
import script from "./DocumentFolders.vue?vue&type=script&lang=js&"
export * from "./DocumentFolders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports